export enum TagSlugs {
  REFERRER_NOT_A_LEAD = 'referrer-not-a-lead'
}
